// This will help the central image manager modal to remember what images are selected.
// Improvements:
// --> Add 'selectAll' feature
// --> 'pruneInvalidSelectedImages' for syncing with deleted images
// --> getSelectedCount for optimization

import { create } from "zustand";

export const useImageSelections = create((set, get) => ({
  // map of contextKeys and array of seleced instanceIds
  selections: {},

  // Get selected instanceIds for a given context
  getSelection: (contextKey) => {
    return get().selections[contextKey] || [];
  },

  // Set the full instanceId array for a given context
  setSelection: (contextKey, instanceIds) => {
    set((state) => ({
      selections: {
        ...state.selections,
        [contextKey]: instanceIds,
      },
    }));
  },

  // Toggle an instanceId by select or deselect action
  toggleImage: (contextKey, instanceId, maxSelect = Infinity) => {
    const current = get().selections[contextKey] || [];

    // If already selected, deselect it
    if (current.includes(instanceId)) {
      return set((state) => ({
        selections: {
          ...state.selections,
          [contextKey]: current.filter((id) => id !== instanceId),
        },
      }));
    }

    // If over limit, block
    if (current.length >= maxSelect) return;

    // Add new instanceId
    set((state) => ({
      selections: {
        ...state.selections,
        [contextKey]: [...current, instanceId],
      },
    }));
  },

  // Clear all selections for a context
  clearSelection: (contextKey) => {
    set((state) => {
      const updated = { ...state.selections };
      delete updated[contextKey];
      return { selections: updated };
    });
  },

  // Check if an instanceId is selected
  isSelected: (contextKey, instanceId) => {
    return (get().selections[contextKey] || []).includes(instanceId);
  },

  // Get all selections (all context keys)
  getAllSelections: () => {
    return get().selections;
  },
}));
